module.exports = __webpack_public_path__ + "static/media/warm-up.fe669b9e.mp4";